import React from "react";
import { DuplicateIcon, StyledLabel } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { Input } from "reactstrap";
import classnames from "classnames";

import store, { setIsEdited } from "../store";
import { ImageUploader } from "../ImageUploader";

type DeliverooConfigType = {
    setDeliverooIdentifier: Function;
    deliverooIdentifier: any;
    isConsult: boolean;
    shopId: any;
    setBrandId: Function;
    brandId: any;
    dataAggregator: any;
    uploadedImage: any;
    setUploadedImage: Function;
    errorMessage: string;
    setErrorMessage: Function;
};
export function DeliverooConfig({
    setDeliverooIdentifier,
    deliverooIdentifier,
    isConsult,
    shopId,
    setBrandId,
    brandId,
    dataAggregator,
    uploadedImage,
    setUploadedImage,
    errorMessage,
    setErrorMessage,
}: DeliverooConfigType) {
    const { isConsultModalOpened } = useSnapshot(store);
    const { t } = useTranslation();
    const [secondPartIdentifier, setSecondPartIdentifier] = React.useState(
        deliverooIdentifier.substring(shopId.length + 1)
    );
    const [inputImage, setInputImage] = React.useState<boolean>(false);
    const [img, setImg] = React.useState("");
    const isJpgOrPng =
        img === "image/jpeg" ||
        img === "image/png" ||
        img === "image/ico" ||
        img === "image/jpg" ||
        /\.(jpg|png|ico|jpeg)$/i.test(uploadedImage?.name);
    const [inputImageUploader] = React.useState<boolean>(false);

    const handleCopyToClipboard = () => {
        const combinedValue =
            secondPartIdentifier.length === 0
                ? `${shopId}`
                : `${deliverooIdentifier}`;

        navigator.clipboard.writeText(combinedValue); // Copy to clipboard
        alert(`Copied: ${combinedValue}`);
    };

    return (
        <React.Fragment>
            <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="mt-3" htmlFor="name">
                    {t("Deliveroo Establishment ID")}
                </StyledLabel>
                <div className="d-flex justify-content-between align-items-center">
                    <Input
                        type="text"
                        id="Webhook"
                        name="Webhook"
                        value={shopId}
                        disabled
                        style={{
                            flexBasis: "20%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    />
                    <Input
                        className={classnames("agr_inp_Webhook mr-2", {
                            "not-allowed-aggregator__clz": isConsultModalOpened,
                        })}
                        autocomplete="off"
                        id="Webhook"
                        name="Webhook"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            setIsEdited(true);
                            setSecondPartIdentifier(e.target.value);
                            setDeliverooIdentifier(
                                e.target.value === ""
                                    ? `${shopId}`
                                    : `${shopId}_${e.target.value}`
                            );
                        }}
                        style={{
                            flexBasis: "70%",
                        }}
                        value={secondPartIdentifier}
                    />
                    <button
                        className="btn d-flex align-items-center"
                        style={{
                            border: "1px solid #ced4da",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "51px",
                        }}
                        onClick={handleCopyToClipboard}
                    >
                        <DuplicateIcon
                            style={{
                                height: "10%",
                                width: "100%",
                            }}
                        />
                    </button>
                </div>
                <div>
                    {t(
                        "This identifier must also be entered on the POS server."
                    )}
                </div>
            </AvGroup>
            <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="mt-3" htmlFor="name">
                    {t("Brand ID")}
                </StyledLabel>
                <Input
                    type="text"
                    id="brandId"
                    name="brandId"
                    value={brandId}
                    onChange={(e: any) => {
                        setIsEdited(true);
                        setBrandId(e.target.value);
                    }}
                    style={{
                        flexBasis: "20%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    placeholder={t("Enter brand ID")}
                />
            </AvGroup>
            <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3">
                    {t("Image of the Deliveroo store")}
                </StyledLabel>
                ({t("PNG, JPG, JPEG, 533x300 px")})
                <ImageUploader
                    uploadedImage={uploadedImage}
                    setUploadedImage={setUploadedImage}
                    inputImage={inputImage}
                    setIsEdited={setIsEdited}
                    setImg={setImg}
                    isJpgOrPng={isJpgOrPng}
                    setInputImage={setInputImage}
                    rowData={dataAggregator}
                    inputImageUploader={inputImageUploader}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                />
                {inputImage || inputImageUploader ? (
                    <div
                        className="ml-5"
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t(
                            "Please insert a PNG, JPG or JPEG (533x300 px) image."
                        )}
                    </div>
                ) : null}
            </AvGroup>
        </React.Fragment>
    );
}
